/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 8/28/2023
 */
import React, { useState } from "react"
import "../../../styleSheets/base/styles.scss"
import "../Styles/userPermission.styles.scss"
import {
  Avatar,
  Card,
  CardActions,
  Button,
  CardHeader,
  IconButton,
  Menu,
  Stack,
  Grow,
  Box,
  Tooltip
} from "@mui/material"
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep"
import EditNoteIcon from "@mui/icons-material/EditNote"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import Helpers from "../../utils/Helpers"

const ApproveCardItem = (props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  function getRandomColor() {
    const hue = Math.floor(Math.random() * 360)
    const saturation = 50 + Math.random() * 25
    const lightness = 75 + Math.random() * 10

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`
  }

  function ColorGenerator() {
    const currentColor = getRandomColor()
    return currentColor
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Grow in={true} className="transformOrigin" timeout={1000}>
      <Card
        sx={{
          maxWidth: 385,
          width: 380,
          height: 215,
          boxShadow: 3,
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <CardHeader
          className="userPermissionCardHeader"
          avatar={
            <Avatar sx={{ bgcolor: ColorGenerator() }} aria-label="recipe">
              {Helpers.firstLetterFormat(
                Helpers.underscoreRoleFormat(props.roleTitle)
              )}
            </Avatar>
          }
          title={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Tooltip title={Helpers.underscoreRoleFormat(props.roleTitle)}>
                <h5
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "200px",
                    cursor:"pointer"
                  }}
                >
                  {Helpers.underscoreRoleFormat(props.roleTitle)}
                </h5>
              </Tooltip>
            </Box>
          }
          action={
            <div>
              <IconButton aria-label="settings" onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <Stack direction="column" spacing={1} alignItems="flex-start">
                  <Button
                    onClick={() => {
                      props.setEditModalOpen(true)
                      handleClose()
                    }}
                    startIcon={<EditNoteIcon />}
                    color="success"
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                      props.setDeleteModalopen(true)
                      handleClose()
                    }}
                    startIcon={<DeleteSweepIcon />}
                    color="error"
                  >
                    Delete
                  </Button>
                </Stack>
              </Menu>
            </div>
          }
        />
        <br />
        <div className="upserPermissionCardBody fontColor">
          <p>{Helpers.underscoreRoleFormat(props.level)}</p>
        </div>
        <CardActions className="userPermissionCardAction">
          <Button size="small" onClick={() => props.setPermModalOpen(true)}>
            Show Permissions
          </Button>
        </CardActions>
      </Card>
    </Grow>
  )
}

export default ApproveCardItem
